import axios from 'axios'
import { getBookConfig } from '@/utils/bookConfig'

export class InvoicePaymentService {
  constructor () {
    this.client = axios.create({
      baseURL: `${process.env.VUE_APP_PUBLIC_API_PROXY_DOMAIN}/payments/`
    })

    this.practiceUuid = getBookConfig().get('practiceUuid')

    if (!this.practiceUuid) {
      throw new Error('Practice UUID is not defined')
    }
  }

  getMerchantByPractice () {
    return this.client.get(`/v1/practices/${this.practiceUuid}/merchant`)
      .then(response => response?.data?.data?.merchant)
  }

  createSyntheticInvoice ({
    firstName,
    lastName,
    dateOfBirth,
    email,
    mobilePhone,
    description,
    amount,
    source,
    sourceId
  }) {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC'
    }
    const dob = new Intl.DateTimeFormat('fr-CA', options).format(new Date(dateOfBirth))
    const body = {
      patient_info: {
        email,
        first_name: firstName,
        last_name: lastName,
        mobile_phone: mobilePhone,
        date_of_birth: dob
      },
      invoice_info: {
        amount,
        description
      },
      source_info: {
        source,
        source_id: String(sourceId)
      }
    }
    return this.client
      .post(`/v1/practices/${this.practiceUuid}/synthetic-invoices`, body)
      .then(response => response.data.data)
  }
}
